import SvgContainer from './svg-container';

export default SvgContainer;
